export default __webpack_public_path__ + "static/media/cloud_storage.926f3804.svg";